import * as React from "react";
const SvgFiRrHandBackFist = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-back-fist_svg__a)">
      <path
        fill="#062147"
        d="M19.006 1.954 9.9.084a4.06 4.06 0 0 0-3.398.834 4.06 4.06 0 0 0-1.5 3.161v.181L1.184 8.042a4.02 4.02 0 0 0-.067 5.615l4.883 5.065V20c0 2.206 1.794 4 4 4h7c2.206 0 4-1.794 4-4v-2.808l1.428-3.569c.38-.949.572-1.948.572-2.97v-3.8a5.02 5.02 0 0 0-3.994-4.899zM21 10.652c0 .767-.145 1.517-.43 2.23l-1.499 3.748a1 1 0 0 0-.07.371v3c0 1.103-.898 2-2 2h-7c-1.104 0-2-.897-2-2v-1.68c0-.259-.102-.508-.28-.694l-5.163-5.356a2.01 2.01 0 0 1 .035-2.808L5 7.076V11a1 1 0 1 0 2 0V4.08a2.076 2.076 0 0 1 2.497-2.036l9.106 1.87A3.01 3.01 0 0 1 21 6.851z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-back-fist_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandBackFist;
